export default {
  meshUrl (state) {
    return state.meshurl
  }
}
